import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';

import { IonicModule } from '@ionic/angular';

import { PlanMarkerDocPage } from './plan-marker-doc.page';
import { SharedModule } from 'src/app/_shared/shared.module';
import { ExtFilesComponentModule } from 'src/app/_components/ext-files/ext-files.module';
import { DataListModule } from 'src/app/_components/data-list/data-list.module';

const routes: Routes = [
  {
    path: '',
    component: PlanMarkerDocPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    RouterModule.forChild(routes),
    SharedModule,
    ExtFilesComponentModule
  ],
  declarations: [PlanMarkerDocPage]
})
export class PlanMarkerDocModule {}
